import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Home from './pages/Home.jsx'
import Form from './pages/form/Form.jsx'
import About from './pages/about/About.jsx'
import Profile from './pages/Profile/Profile.jsx'
import PageNotFound from './pages/PageNotFound.jsx'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: '/form',
        element: <Form />
        // element:<Home />
      },
      {
        path: '/profile',
        element: <Profile />
        // element:<Home />
      },
      {
        path: '/about',
        element: <About />
      },
      {
        path: "/*",
        element:<PageNotFound />
      }
    ]
  }
])

createRoot(document.getElementById('root')).render(
  // <StrictMode>
    
    <RouterProvider router={router} />
  // </StrictMode>,
)
